export var IFnoBanMsg;
(function (IFnoBanMsg) {
    IFnoBanMsg["SECURITIES"] = "securitiesMessage";
    IFnoBanMsg["POSSIBLE_ENTRANCE"] = "possibleEntranceMassage";
    IFnoBanMsg["POSSIBLE_EXITS"] = "possibleExitsMessage";
})(IFnoBanMsg || (IFnoBanMsg = {}));
export var optionMsgIcon;
(function (optionMsgIcon) {
    optionMsgIcon["LIMIT"] = "edel-icon-emtpy_icon";
    optionMsgIcon["DEFAULT"] = "";
})(optionMsgIcon || (optionMsgIcon = {}));
export var IFnoBanSectionType;
(function (IFnoBanSectionType) {
    IFnoBanSectionType["SECURITIES"] = "securities";
    IFnoBanSectionType["POSSIBLE_ENTRANCE"] = "possibleEntrance";
    IFnoBanSectionType["POSSIBLE_EXITS"] = "possibleExits";
})(IFnoBanSectionType || (IFnoBanSectionType = {}));
